import * as yup from 'yup'
import { useIntl } from 'react-intl'

export const SelectPersonTypeSchema = () => {
  const { formatMessage } = useIntl()

  return yup.object().shape({
    personType: yup.string().required(formatMessage({ id: 'REQUIRED_FIELD' })),
    nationality: yup.string().required(formatMessage({ id: 'REQUIRED_FIELD' })),
    bankCountry: yup.string().required(formatMessage({ id: 'REQUIRED_FIELD' })),
    meetingLanguages: yup
      .array()
      .of(yup.string())
      .min(1, formatMessage({ id: 'REQUIRED_FIELD' }))
      .required(formatMessage({ id: 'REQUIRED_FIELD' })),
    otherLanguage: yup.string().when('meetingLanguages', {
      is: (val: string[]) => val.includes('other'),
      then: yup
        .string()
        .max(30, formatMessage({ id: 'MAX_30_CHARACTERS' }))
        .required(formatMessage({ id: 'REQUIRED_FIELD' })),
    }),
    howDiscoverUs: yup
      .string()
      .required(formatMessage({ id: 'REQUIRED_FIELD' })),
  })
}
